import IndustryBenefitsI18n from "@/components/landing/shared/IndustryBenefitsI18n";
import { TrendingUp, Heart, PiggyBank, Users } from "lucide-react";
const VorteileECommerceSection = () => <IndustryBenefitsI18n translationPrefix="industryECommerce" icons={[TrendingUp, Heart, PiggyBank, Users]} />;
export default VorteileECommerceSection;
